import React, { Dispatch, FC, SetStateAction } from 'react'
import axios from 'ps-components/lib/apiClient';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import { GetCustomParticipationReportDataReponse, ParticipationReport, Survey } from './types';
import { IAppState } from '../../../lib/types';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

type Props = {
    selectedReport?: ParticipationReport
    setSelectedReport: Dispatch<SetStateAction<ParticipationReport | undefined>>
    selectedSurvey: Survey | undefined
}

export const ParticipationsReportCard: FC<Props> = ({ selectedReport, setSelectedReport, selectedSurvey }) => {
    const { masterAccountId } = useSelector((state: IAppState) => state.session)

    const fetchReports = async (): Promise<ParticipationReport[]> => {
        const response = await axios.apiGet(`/cms/api/accounts/${masterAccountId}/customParticipationReports?surveyCode=${selectedSurvey?.code}`)
        const reports = response.data.map((r: GetCustomParticipationReportDataReponse): ParticipationReport => ({
            pk: r.report_pk,
            name: r.report_name,
        }))
        return reports
    }

    const { data, isLoading, isError } = useQuery(['P_CENTER_REPORTS', { surveyCode: selectedSurvey?.code }], fetchReports, { refetchOnWindowFocus: false, retry: 1 })

    if (!selectedSurvey) return null
    if (isLoading) return <LoadingIndicator loading={isLoading} />
    if ((data && data.length < 1) || isError) return <h3 className='pcenter-slideout__error_msg'>No previous participation reports found.</h3>

    return (
        <ActionableHeaderCard cardTitle={!selectedReport ? 'Select Participation Report' : `Participation Report: ${selectedReport.name}`} isCollapsible={true}>
            <div className="pcenter-slideout__table_container">
                <table className='pcenter-slideout__table'>
                    <tbody>
                    {data?.map((r, i) => (
                        <tr key={i} className={r.pk === selectedReport?.pk ? 'pcenter-slideout__table_row_selected' : 'pcenter-slideout__table_row'} onClick={() => setSelectedReport(r)}>
                            <td className='pcenter-slideout__table_data'>{r.name}</td>
                            <td className='pcenter-slideout__table_data_year'>{selectedSurvey?.year}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </ActionableHeaderCard>
    )
}